/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>标签管理</el-breadcrumb-item></el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="add"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="labelList"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column
        prop="name"
        label="标签名字"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="description"
        label="内容说明"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="type"
        label="颜色"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div style="color: #409eff" v-if="scope.row.type == 'primary'">
            <i class="el-icon-s-flag"></i>
          </div>
          <div style="color: #e6a23c" v-else-if="scope.row.type == 'warning'">
            <i class="el-icon-s-flag"></i>
          </div>
          <div style="color: #67c23a" v-else-if="scope.row.type == 'success'">
            <i class="el-icon-s-flag"></i>
          </div>
          <div style="color: #f56c6c" v-else-if="scope.row.type == 'error'">
            <i class="el-icon-s-flag"></i>
          </div>
          <div style="color: #b76cf5" v-else-if="scope.row.type == 'royal'">
            <i class="el-icon-s-flag"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip>
      </el-table-column>

      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >修改</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="deleteLabel(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination> -->
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="50%"
      @click="closeDialog('editForm')"
    >
      <el-form label-width="120px" :model="editForm" ref="editForm" >
        <el-row>
          <el-col :span="20" >
            <el-form-item label="名称">
              <el-input
                size="small"
                v-model="editForm.name"
                auto-complete="off"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="内容">
              <el-input
                size="small"
                v-model="editForm.description"
                auto-complete="off"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
            <el-form-item label="颜色">
              <el-select v-model="editForm.type" placeholder="请选择">
                <el-option
                  v-for="item in colorRange"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('edit')">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { OrderList, OrderRefund, OrderDelete } from "../../api/payMG";
import Pagination from "../../components/Pagination";

import {
  getOrder,
  getLabelList,
  addLabel,
  editLabel,
  deleteLabel,
} from "@/api/api.js";
import { get } from "../../api/request";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "修改",
      date: "",
      year: "",
      month: "",
      day: "",
      orderStatus: "", //订单类型
      labelList: [], //标签列表
      payway: [
        { key: "全部订单", value: 0 },
        { key: "已完成订单", value: 1 },
        { key: "已取消订单", value: 2 },
        { key: "已退款订单", value: 3 },
      ],
      orderList: "", //订单列表
      editForm: {
        id: "",
        name: "",
        payType: 1,
        partner: "",
        subMchId: "",
        appid: "",
        notifyUrl: "",
        signType: "",
        partnerKey: "",
        sellerUserId: "",
        certPath: "",
        certPassword: "",
        rsaKey: "",
        token: localStorage.getItem("logintoken"),
      },
      colorRange: [
        {
          text: "蓝色",
          value: "primary",
        },
        {
          text: "绿色",
          value: "success",
        },
        {
          text: "紫色",
          value: "royal",
        },
        {
          text: "黄色",
          value: "warning",
        },
        {
          text: "红色",
          value: "error",
        },
      ],
      formInline: {
        page: 1,
        limit: 10,
        machineNo: "",
        orderNo: "",
        transId: "",
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline);
    this.getData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取订单数据
    getData() {
      getLabelList().then((res) => {
        console.log(res);
        this.labelList = res.data;
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.pageparm.currentPage = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.pageparm.pageSize = parm.pageSize;
      // this.getdata(this.formInline)
      this.getData();
    },
    // 搜索事件
    add() {
      // this.getdata(this.formInline)
      this.editFormVisible = true;
        this.title = "添加";
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = row;
      console.log(index, row, "333333");
    },
    // 编辑、增加页面保存方法
    submitForm() {
        this.loading = true;
        editLabel({
            tagId:this.editForm.tagId,
            name:this.editForm.name,
            description:this.editForm.description,
            type:this.editForm.type
        }).then((res)=>{
            this.loading = false;
            if(res.code == 0){
                this.$message({
                    type: 'success',
                    message: '保存成功！'
                })
                this.editFormVisible = false;
                this.getdata();
            }else{
                this.$message({
                    type: 'info',
                    message: res.msg
                })
            }
        })

    },
    // 删除标签
    deleteLabel(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteLabel(row.tagId)
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "已删除!",
                });
                this.getdata();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/system/Label.vue